import { Star } from 'lucide-react';

export default function StarRating({ rating, totalReviews, size = 'sm', showCount = true }) {
    const sizes = {
        xs: 'h-2.5 w-2.5',
        sm: 'h-3 w-3',
        md: 'h-4 w-4',
        lg: 'h-5 w-5',
        xl: 'h-6 w-6'
    };

    const textSizes = {
        xs: 'text-[10px]',
        sm: 'text-xs',
        md: 'text-sm',
        lg: 'text-base',
        xl: 'text-lg'
    };

    const starSize = sizes[size] || sizes.sm;
    const textSize = textSizes[size] || textSizes.sm;

    // If no rating, show empty state
    if (!rating || rating === 0) {
        return (
            <div className="flex items-center gap-1">
                <div className="flex text-gray-300">
                    {[1, 2, 3, 4, 5].map((star) => (
                        <Star key={star} className={starSize} />
                    ))}
                </div>
                {showCount && (
                    <span className={`${textSize} text-gray-400`}>
                        Aucun avis
                    </span>
                )}
            </div>
        );
    }

    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    return (
        <div className="flex items-center gap-1">
            <div className="flex text-yellow-400">
                {[1, 2, 3, 4, 5].map((star) => {
                    if (star <= fullStars) {
                        return <Star key={star} className={`${starSize} fill-current`} />;
                    } else if (star === fullStars + 1 && hasHalfStar) {
                        return (
                            <div key={star} className="relative">
                                <Star className={`${starSize} text-gray-300`} />
                                <div className="absolute inset-0 overflow-hidden w-1/2">
                                    <Star className={`${starSize} fill-current text-yellow-400`} />
                                </div>
                            </div>
                        );
                    } else {
                        return <Star key={star} className={`${starSize} text-gray-300`} />;
                    }
                })}
            </div>
            {showCount && totalReviews !== undefined && (
                <span className={`${textSize} text-blue-600 hover:underline cursor-pointer`}>
                    {totalReviews > 0 ? totalReviews : ''}
                </span>
            )}
        </div>
    );
}
